import Router from 'vue-router'
import Vue from 'vue'
import i18n from '@/i18n'
import store from '@/store/store'
import { privilegesService } from './services/privilegesService'
import { RESET_PASSWORD_TYPES } from '@colven/common-domain-lib/lib'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/app',
      name: 'home',
      component: () => import('./views/ABMView.vue'),
      children: [
        {
          path: '',
          name: 'homeDashboard',
          component: () => import('./components/home/HomeComponent.vue')
        },
        {
          path: 'profile-abm',
          name: 'profileABM',
          component: () => import('./components/profile/ProfileABMComponent.vue')
        },
        {
          path: 'gps-history/:id',
          name: 'GpsHistory',
          component: () => import('./components/gps/history/GpsHistoryComponent.vue'),
        },
        {
          path: 'gps-abm',
          name: 'GpsABM',
          component: () => import('./components/gps/GpsABMComponent.vue'),
        },
        {
          path: 'equipment-abm',
          name: 'equipmentABM',
          component: () => import('./components/thing/ThingABMComponent.vue'),
        },
        {
          path: 'line-abm',
          name: 'LinesABM',
          component: () => import('./components/line/LineABMComponent.vue'),
        },
        {
          path: 'enterprise-abm',
          name: 'EnterpriseABM',
          component: () => import('./components/enterprise/EnterpriseABMComponent.vue'),
        },
        {
          path: 'group-abm',
          name: 'GroupABM',
          component: () => import('./components/group/GroupABMComponent.vue'),
        },
        {
          path: 'fleet-abm',
          name: 'FleetABM',
          component: () => import('./components/fleet/FleetABMComponent.vue'),
        },
        {
          path: 'work-front-abm',
          name: 'WorkFrontABM',
          component: () => import('./components/work-front/WorkFrontABMComponent.vue'),
        },
        {
          path: 'farm-abm',
          name: 'FarmABM',
          component: () => import('./components/farm/FarmABMComponent.vue'),
        },
        {
          path: 'ecological-unit-abm',
          name: 'EcologicalUnitABM',
          component: () => import('./components/ecological-unit/EcologicalUnitABMComponent.vue'),
        },
        {
          path: 'zone-abm',
          name: 'ZoneABM',
          component: () => import('./components/zone/ZoneABMComponent.vue'),
        },
        {
          path: 'user-abm',
          name: 'UserABM',
          component: () => import('./components/user/UserABMComponent.vue'),
        },
        {
          path: 'person-abm',
          name: 'PersonABM',
          component: () => import('./components/person/PersonABMComponent.vue'),
        },
        {
          path: 'event-type-abm',
          name: 'EventTypeABM',
          component: () => import('./components/event-type/EventTypeABMComponent.vue'),
        },
        {
          path: 'state-type-abm',
          name: 'StateTypeABM',
          component: () => import('./components/state-type/StateTypeABMComponent.vue'),
        },
        {
          path: 'category-abm',
          name: 'CategoryABM',
          component: () => import('./components/category/CategoryABMComponent.vue'),
        },
        {
          path: 'alert-event-abm',
          name: 'AlertEventABM',
          component: () => import('./components/alert-event/AlertEventABMComponent.vue'),
        },
        {
          path: 'goals-abm',
          name: 'GoalsABM',
          component: () => import('./components/goals/GoalsABMComponent.vue'),
        },
        {
          path: 'current-state',
          name: 'CurrentStateComponent',
          component: () => import('./components/current-state/CurrentStateComponent.vue'),
        },
        {
          path: 'track-disorder',
          name: 'trackDisorder',
          meta: { keys: { and: ['backoffice.trackDisorder'] } },
          component: () => import('./components/trackDisorder/TrackDisorderComponent.vue')
        },
        {
          path: 'track-status',
          name: 'trackStatus',
          meta: { keys: { and: ['backoffice.trackStatus'] } },
          component: () => import('./components/trackStatus/TrackStatusComponent.vue')
        },
        {
          path: 'notification-status',
          name: 'NotificationStatus',
          component: () => import('./components/notificationStatus/NotificationStatusComponent.vue')
        },
        {
          path: 'pims-logs',
          name: 'pimsLogs',
          meta: { keys: { and: ['backoffice.pimsLogs'] } },
          component: () => import('./components/pimsLogs/PimsLogsComponent.vue')
        },
        {
          path: 'forward',
          name: 'forward',
          meta: { keys: { and: ['backoffice.forward'] } },
          component: () => import('./components/forward/ForwardComponent.vue')
        }
      ]
    },
    {
      path: '/command',
      name: 'command',
      component: () => import('./views/CommandView.vue'),
      children: [
        {
          path: 'sent',
          name: 'SentCommandsReport',
          component: () => import('./components/command/sent-commands-report/SentCommandsReport.vue'),
        },
        {
          path: 'massive-upload',
          name: 'CommandMassiveUpload',
          component: () => import('./components/command/massive-upload/CommandMassiveUploadComponent.vue'),
        }
      ]
    },
    {
      path: '/login',
      component: () => import('./views/LoginView.vue'),
      children: [
        {
          path: '',
          name: 'login',
          component: () => import('./components/login/LoginComponent.vue')
        },
        {
          path: 'reset-password',
          name: 'emailResetPassword',
          component: () => import('./components/reset-password/email/EmailResetPasswordComponent.vue')
        }
      ]
    },
    {
      path: '/reset-password/user/:token',
      name: 'resetPasswordUser',
      meta: { type: RESET_PASSWORD_TYPES.USER_RESET },
      component: () => import('./views/ResetPasswordView.vue')
    },
    {
      path: '/reset-password/next-login/:token',
      name: 'resetPasswordNextLogin',
      meta: { type: RESET_PASSWORD_TYPES.NEXT_LOGIN },
      component: () => import('./views/ResetPasswordView.vue')
    },
    {
      path: '/reset-password/expiration/:token',
      name: 'resetPasswordExpiration',
      meta: { type: RESET_PASSWORD_TYPES.EXPIRATION },
      component: () => import('./views/ResetPasswordView.vue')
    },
    {
      path: '/scoring',
      name: 'scoring',
      component: () => import('./views/ScoringView.vue'),
      children: [
        {
          path: 'discarded-infractions',
          name: 'DiscardedInfractionsReport',
          component: () => import('./components/scoring/discarded-infractions/DiscardedInfractionsReport.vue'),
        }
      ]
    },
    { path: '*', redirect: '/app' }
  ]
});

router.beforeEach((to, from, next) => {
  // Configurar lenguaje
  if (localStorage.getItem('locale')) {
    i18n.locale = localStorage.getItem('locale')
  } else {
    i18n.locale = navigator.language
  }

  // Ocultar header y footer en el login
  if (to && (to.name === 'login' || to.name === 'resetPasswordUser' || to.name === 'resetPasswordExpiration' || to.name === 'resetPasswordNextLogin' || to.name === 'emailResetPassword')) {
    store.dispatch('app/hideHeader')
  } else {
    store.dispatch('app/showHeader')
    if (!localStorage.getItem('token')) {
      next({
        path: '/login'
      })
      return
    } else {
      // privilegios
      if (!JSON.parse(localStorage.getItem('admin'))) {
        if (to.meta && to.meta.keys) {
          const result = privilegesService.validatePrivileges(to.meta.keys)
          if (!result) {
            next({
              path: '/app'
            })
            return
          }
        }
      }
    }
  }

  next()
})

export default router;
